
export const TASKS = [{
    key: "update_user_meta",
    label: "Update user meta"
}, {
    key: "send_system_message",
    label: "Send message"
}, {
    key: "season_end",
    label: "Test season end"
}]
